/**
 * PROD-3347 — why a price came back without the patient's co-payment.
 *
 * Practice.Aggregator (#172) adds `coPaymentWarning` to PreBookSelectedPatient,
 * PreBookCalculatePrice and PostBookCalculatePrice when the booking's sponsor
 * has an agreement but the patient has no active insurance for it (changed
 * insurer, row deactivated, or never added). The price is still calculated,
 * without a co-payment; booking is not blocked. Absent or null otherwise.
 */
export interface CoPaymentWarning {
  code: 'no-active-insurance-for-sponsor';
  sponsorId: string;
  /** Billing's agreement name for the sponsor; can be null. */
  sponsorName?: string | null;
}

/** Reads the wire field; anything that is not the known warning reads as none. */
export function toCoPaymentWarning(raw: unknown): CoPaymentWarning | null {
  if (!raw || typeof raw !== 'object') return null;
  const w = raw as { code?: unknown; sponsorId?: unknown; sponsorName?: unknown };
  if (w.code !== 'no-active-insurance-for-sponsor' || typeof w.sponsorId !== 'string') return null;
  return {
    code: w.code,
    sponsorId: w.sponsorId,
    sponsorName: typeof w.sponsorName === 'string' && w.sponsorName.trim() ? w.sponsorName : null,
  };
}

/** The sentence the price panels show. */
export function coPaymentWarningText(warning: CoPaymentWarning): string {
  return `No active insurance for ${warning.sponsorName ?? 'this insurer'}. Update the patient's insurance.`;
}
